module.exports = __webpack_public_path__ + "img/shengli.9818b72c.png";